import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const GrantForm = ({
  formData,
  setFormData,
  onSubmit,
  onCancel,
  submitting,
  isEdit
}) => {

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {isEdit ? 'Edit Grant' : 'Add Grant'}
        </CardTitle>
      </CardHeader>

      <CardContent>
        <form onSubmit={onSubmit} className="space-y-6">

          <div>
            <Label>Grant Name</Label>
            <Input
              value={formData.name}
              onChange={(e) => handleChange('name', e.target.value)}
              required
            />
          </div>

          <div>
            <Label>Amount</Label>
            <Input
              value={formData.amount}
              onChange={(e) => handleChange('amount', e.target.value)}
              required
            />
          </div>

          <div>
            <Label>Category</Label>
            <Input
              value={formData.category}
              onChange={(e) => handleChange('category', e.target.value)}
              required
            />
          </div>

          <div>
            <Label>Deadline</Label>
            <Input
              type="date"
              value={formData.deadline}
              onChange={(e) => handleChange('deadline', e.target.value)}
              required
            />
          </div>

          <div>
            <Label>Status</Label>
            <select
              value={formData.status}
              onChange={(e) => handleChange('status', e.target.value)}
              className="w-full border rounded px-3 py-2"
            >
              <option value="Open">Open</option>
              <option value="Closed">Closed</option>
            </select>
          </div>

          <div className="flex justify-end gap-4">
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              className="bg-medicaps-blue hover:bg-medicaps-blue/90"
              disabled={submitting}
            >
              {submitting
                ? 'Saving...'
                : isEdit ? 'Update Grant' : 'Create Grant'}
            </Button>
          </div>

        </form>
      </CardContent>
    </Card>
  );
};

export default GrantForm;